// @mui
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
// theme
import { hideScroll } from 'src/theme/css';
// hooks
import { useMockedUser } from 'src/hooks/use-mocked-user';
// components
import Logo from 'src/components/logo';
import { NavSectionMini } from 'src/components/nav-section';
//
import { NAV } from '../config-layout';
import { useNavData } from './config-navigation';
import { NavToggleButton } from '../_common';
import { useRouter } from 'src/routes/hooks';
import { paths } from 'src/routes/paths';
import { useCallback, useEffect, useState } from 'react';
import { useSnackbar } from 'notistack';
import { useUploadImageMutation } from 'src/store/Reducer/file';
import { useAddFolderMutation } from 'src/store/Reducer/folder';
import { useBoolean } from 'src/hooks/use-boolean';
import { toast } from 'react-toastify';
import FileManagerNewFolderDialog from 'src/sections/file-manager/file-manager-new-folder-dialog';

// ----------------------------------------------------------------------

export default function NavMini() {
  const { user } = useMockedUser();

  const { data, openModal, handleOpenModal, handleCloseModal } = useNavData();

  // const [location, setLocation] = useState(null);

  const router = useRouter();


  const [folderName, setFolderName] = useState('');

  const [caption, setCaption] = useState('');

  const [selectedCategory, setSelectedCategory] = useState('');

  const [files, setFiles] = useState([]);

  const [creatingLoading, setCreatingLoading] = useState(false);

  const is_confidential = useBoolean();

  const { enqueueSnackbar } = useSnackbar();

  const [uploadImage] = useUploadImageMutation();

  const [addFolder] = useAddFolderMutation();

  // const getLocationFromCoords = async coords => {
  //   try {
  //     const response = await fetch(
  //       `https://nominatim.openstreetmap.org/reverse?lat=${coords.latitude}&lon=${coords.longitude}&format=json&addressdetails=1`,
  //     );
  //     return await response.json();
  //   } catch (error) {
  //     console.error('Error fetching address from coordinates:', error);
  //   }
  // };

  // useEffect(() => {
  //   navigator.geolocation.getCurrentPosition(
  //     async (position) => {
  //       let response = await getLocationFromCoords(position.coords);
  //       setLocation(response?.display_name || 'Unknown location');
  //     },
  //     (err) => console.error("Error getting location:", err)
  //   );

  // }, [])

  const handleChangeFolderName = useCallback((event) => {
    setFolderName(event.target.value);
  }, []);

  const handleCreateNewFolder = async () => {
    try {
      if ((!folderName.trim() && enqueueSnackbar('Folder name is required', { variant: 'error' })) ||
        (!selectedCategory && enqueueSnackbar('Please select a category', { variant: 'error' })) ||
        ((!files || files?.length === 0) && enqueueSnackbar('Please upload at least one file', { variant: 'error' }))
      ) return;

      setCreatingLoading(true);

      const formData = new FormData();

      files.forEach((file) => {
        formData.append('files[]', file);
      });

      formData.append('UPLOAD_IDENTIFIER', folderName);

      const uploadResult = await uploadImage(formData).unwrap();

      const newData = {
        category_id: selectedCategory,
        project: folderName,
        caption,
        files: uploadResult?.data?.uploaded,
        is_confidential: is_confidential.value
      }
       const responce =  await addFolder(newData).unwrap();
      if (!responce?.error) {
          handleCloseModal();
          enqueueSnackbar('New Folder uploaded successfully');
          window.location.reload();
        }
    } catch (error) {
      setCreatingLoading(false)
      toast.error(error?.data?.message || 'Failed to Upload Folder');
    } finally {
      setCreatingLoading(false);
    }
  };


  return (
    <Box
      component="nav"
      sx={{
        flexShrink: { lg: 0 },
        width: { lg: NAV.W_MINI },
      }}
    >
      <NavToggleButton
        sx={{
          top: 22,
          left: NAV.W_MINI - 12,
        }}
      />

      <Stack
        sx={{
          pb: 2,
          height: 1,
          position: 'fixed',
          width: NAV.W_MINI,
          borderRight: (theme) => `dashed 1px ${theme.palette.divider}`,
          ...hideScroll.x,
        }}
      >
        <Logo
          sx={{ mx: 'auto', my: 2, width: 80, cursor: 'pointer' }}
          onClick={() => router.push(paths.dashboard.root)}
        />

        <NavSectionMini
          data={data}
          config={{
            currentRole: user?.role || 'admin',
          }}
        />
      </Stack>

      <FileManagerNewFolderDialog
        open={openModal}
        creatingLoading={creatingLoading}
        onClose={handleCloseModal}
        title="Upload New Image / Video"
        files={files}
        setFiles={setFiles}
        selectedCategory={selectedCategory}
        setSelectedCategory={setSelectedCategory}
        setCaption={setCaption}
        caption={caption}
        folderName={folderName}
        onChangeFolderName={handleChangeFolderName}
        onCreate={handleCreateNewFolder}
        confidential={is_confidential.value}
        onToggleConfidential={is_confidential.onToggle}
      />
    </Box>
  );
}
